var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoundTubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.392,
    height: 72.654,
    viewBox: "0 0 87.392 72.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 87.392,
    height: 72.654,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-round-tubes",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M22.655,21.789a2.614,2.614,0,0,0,1.877-4.88L8.049,10.567l.1-.7L2.972,7.875l-2.4,6.231,5.2,2,.44-.643Zm-9.178-7.409-.723,1.877L6.621,13.9l.723-1.877Z",
    transform: "translate(1.194 16.356)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M23.378,18.976a2.614,2.614,0,1,0,.1-5.228L5.815,13.426l-.148-.692-5.544-.1L0,19.309l5.569.1.194-.757Zm-11.16-3.825-.037,2.012-6.569-.12.037-2.012Z",
    transform: "translate(0 26.236)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M11.031,8.169l.36-.689-4.2-3.658L2.807,8.858,6.992,12.5l.572-.418,13.32,11.6a2.614,2.614,0,1,0,3.434-3.941ZM8.518,10.781l1.32-1.517,4.957,4.314-1.323,1.517Z",
    transform: "translate(5.83 7.937)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M24.367,20.26a2.614,2.614,0,1,0-1.7-4.945l-16.7,5.738-.372-.6-5.246,1.8,2.169,6.314,5.268-1.809-.077-.775Zm-11.794.225.652,1.9L7.014,24.522l-.652-1.9Z",
    transform: "translate(0.719 31.515)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M14.218,6.449l.575-.526-2.7-4.874L6.255,4.283,8.941,9.135l.68-.2,8.551,15.455a2.614,2.614,0,0,0,4.575-2.529ZM10.963,8.043l1.76-.975L15.9,12.818l-1.76.972Z",
    transform: "translate(12.991 2.18)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M24.394,21.64a2.613,2.613,0,1,0-3.286-4.065L7.373,28.683l-.557-.44L2.5,31.732l4.2,5.191,4.332-3.5-.335-.7ZM13.388,25.886l1.265,1.563L9.545,31.581,8.28,30.015Z",
    transform: "translate(5.196 35.301)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M17.556,5.8l.72-.3L17.412,0l-6.6,1.04.865,5.48.708.049,2.748,17.446A2.615,2.615,0,0,0,20.3,23.2Zm-3.6.385,1.988-.314,1.022,6.489-1.988.314Z",
    transform: "translate(22.461 0.001)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M39.508,15.6l.44.643,5.2-1.988L42.77,8.021,37.585,10l.1.7-16.5,6.3a2.613,2.613,0,0,0,1.865,4.883Zm-1.123-3.446.717,1.88-6.135,2.345-.72-1.88Z",
    transform: "translate(40.511 16.659)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M40.214,18.789l.194.757,5.569-.089-.108-6.677-5.545.089-.148.692-17.661.28a2.614,2.614,0,0,0,.083,5.228Zm.123-3.621.031,2.012-6.569.1-.031-2.009Z",
    transform: "translate(41.419 26.543)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M19.229,19.834a2.614,2.614,0,0,0,3.421,3.954L36,12.218l.572.422,4.191-3.634L36.391,3.96,32.182,7.606l.36.692Zm10.855-4.615L28.767,13.7l4.966-4.3,1.317,1.52Z",
    transform: "translate(38.062 8.225)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M38.081,26.152,38,26.928l5.261,1.821,2.185-6.311-5.24-1.815-.375.6L23.143,15.448a2.615,2.615,0,0,0-1.711,4.941Zm1.354-3.363-.658,1.9L32.567,22.54l.658-1.9Z",
    transform: "translate(40.859 31.786)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M17.028,21.968a2.613,2.613,0,1,0,4.566,2.541L30.184,9.076l.68.2,2.7-4.846L27.726,1.178,25.018,6.046l.575.526Zm8.621-8.052-1.757-.978L27.086,7.2l1.757.978Z",
    transform: "translate(34.679 2.447)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M33.1,32.874l-.338.7,4.323,3.514L41.3,31.908l-4.3-3.5-.557.437L22.725,17.708a2.614,2.614,0,0,0-3.3,4.058Zm2.421-2.7-1.268,1.56-5.1-4.141,1.268-1.56Z",
    transform: "translate(38.348 35.566)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M14.546,23.311a2.613,2.613,0,0,0,5.16.828L22.5,6.7l.7-.049.877-5.477L17.491.118l-.88,5.5.72.3ZM19.894,12.8l-1.988-.317,1.04-6.489,1.985.32Z",
    transform: "translate(30.142 0.246)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundTubes);
export default __webpack_public_path__ + "static/media/icon-round-tubes.e758dad01d584c5de8af5669581227eb.svg";
export { ForwardRef as ReactComponent };